import {
  Breadcrumb,
  DownloadInvoice,
  ErrorAlert,
  Modal,
  PageHero,
  SmsBalanceAlert,
  useEffect,
  useLoading,
  useMemo,
  useParams,
  UserIcon,
  useState,
} from "@";
import { DataTable } from "@/shared/components/tanstackTable";
import { getDonor } from "./utils/api";
import Numbers from "./components/Numbers";
import UserCard from "./components/UserCard";
import SendSMSMessage from "./components/SendSMSMessage";
import { donorColumns } from "./components/tableColumns";

const Index = () => {
  const params = useParams();
  const [info, setInfo] = useState({});
  const [data, setData] = useState([]);
  const [error, setError] = useState(false);
  const { isLoading, loading } = useLoading();
  const [isSmsBalanceLow, setIsSmsBalanceLow] = useState(true);
  const links = [
    { name: "المتبرعين", link: "/donors" },
    { name: "بيانات متبرع", link: "" },
  ];

  // Append invoice-download action column
  const columns = useMemo(
    () => [
      ...donorColumns,
      {
        id: "invoice",
        header: "",
        size: 80,
        cell: ({ row }) =>
          row.original.orderId && (
            <DownloadInvoice
              id={row.original.id}
              title="تحميل الايصال"
              targetId={row.original.orderId}
            />
          ),
      },
    ],
    [],
  );

  const fetchData = async () => {
    try {
      loading(true);
      const { data: donor } = await getDonor(params.id);
      setInfo(donor);
      setData(donor.userOrderDetails);
      setError(false);
    } catch (error) {
      setError(true);
    } finally {
      loading(false);
    }
  };

  const getSmsBalance = (value) => setIsSmsBalanceLow(value);

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <ErrorAlert reload={fetchData} show={error} />
      <SmsBalanceAlert isShow={getSmsBalance} />

      <Breadcrumb links={links} />

      <Modal title="إرسال رسالة SMS">
        <SendSMSMessage info={info} isSmsBalanceLow={isSmsBalanceLow} />
      </Modal>

      {/* Hero header */}
      <main className="table-card relative">
        <PageHero
          eyebrow="المتبرعين / بيانات متبرع"
          title={info?.userName || "بيانات متبرع"}
          icon={UserIcon}
        />

        {/* Donor profile + stats */}
        <div className="mt-4 grid gap-4 lg:grid-cols-3">
          <UserCard info={info} isSmsBalanceLow={isSmsBalanceLow} />
          <Numbers info={info} />
        </div>

        {/* Recent donations */}
        <section className="mt-6">
          <div className="mb-3 flex items-center gap-2.5">
            <span className="hidden h-8 w-1 rounded-full bg-gradient-to-b from-purple-700 to-purple-950 dark:from-purple-400 dark:to-purple-700 md:block" />
            <div>
              <p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-purple-700 dark:text-purple-400">
                السجل
              </p>
              <h2 className="text-base font-bold tracking-tight text-gray-900 dark:text-gray-100">
                أحدث التبرعات
              </h2>
            </div>
          </div>

          <DataTable
            data={data || []}
            columns={columns}
            isLoading={isLoading}
          />
        </section>
      </main>
    </>
  );
};

export default Index;
